import AbstractEntity from "./abstractEntity";
import { SITE_ROLES } from "../constants/roles";

/*
userObj properties:
  - active
  - emailVerified
  - firstName
  - lastName
  - siteRole
  - username
  - leagueRoles
  - franchiseRoles
  - selectedTeam
  - selectedLeagueSeason
 */
class User extends AbstractEntity {
  constructor(userObj, userInfo) {
    super(userObj, userInfo);
    this.loaded = false;

    if (this.obj) {
      this.fullName = `${this.obj.firstName} ${this.obj.lastName}`.trim();

      this.label = this.fullName;
      this.pathDeps = {
        user: this.obj,
      };
      this.defaultPathName = "userHome";

      this.loaded = true;
    }
  }

  /**
   *
   * @returns {boolean}
   */
  hasLoaded() {
    return this.loaded;
  }

  /**
   *
   * @returns {boolean}
   */
  isAdmin() {
    return this.obj.siteRole <= SITE_ROLES.ADMIN;
  }

  /**
   *
   * @returns {boolean}
   */
  isLeagueOfficial(league) {
    return league.hasRoleOfficial(this.obj.username);
  }
}

export default User;
